import { api } from "@/libs/api-client";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const followUserSchema = z.object({
  followeeId: z.string(),
});

export type FollowUserInput = z.infer<typeof followUserSchema>;

export const followUser = createServerFn({ method: "POST" })
  .validator(followUserSchema)
  .handler(async ({ data }) => {
    const response = await api.post("user/follow", {
      searchParams: {
        userId: data.followeeId,
      },
    });

    return response.ok;
  });
